import React from 'react'
import Home from '../../home/Home'
import Buy from '../../home/listings/buy/Buy'

const BuyProperty = () => {
  return (
        <>
        <Home />
        <Buy />
        </>
  )
}

export default BuyProperty
